export default __webpack_public_path__ + "static/media/PageNotFound.91eee9b8.svg";